import { render, staticRenderFns } from "./banddialog.vue?vue&type=template&id=3d2a7123&scoped=true"
import script from "./banddialog.vue?vue&type=script&lang=js"
export * from "./banddialog.vue?vue&type=script&lang=js"
import style0 from "./banddialog.vue?vue&type=style&index=0&id=3d2a7123&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../../../../../../opt/build-cache/yunying/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d2a7123",
  null
  
)

export default component.exports